import { render, staticRenderFns } from "./ScriptStudio.vue?vue&type=template&id=6fe433ae&scoped=true"
import script from "./ScriptStudio.vue?vue&type=script&lang=js"
export * from "./ScriptStudio.vue?vue&type=script&lang=js"
import style0 from "./ScriptStudio.vue?vue&type=style&index=0&id=6fe433ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe433ae",
  null
  
)

export default component.exports